import React from "react";
import { useTranslation } from "react-i18next";
import { Alert, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import { IReorderingModeControlsProps } from "./ReorderingModeControlsInterfaces";
import { useStyles } from "./ReorderingModeControls.styles";

export const ReorderingModeControls: React.FC<IReorderingModeControlsProps> = ({
    onCancel,
    onConfirm,
    isSaving,
}) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Alert severity="info" className={classes.alert}>
                <Typography className={classes.alertText}>{t("HMI.cluster.reordering_mode_message")}</Typography>
            </Alert>
            <button
                type="button"
                disabled={isSaving}
                onClick={onCancel}
                className={isSaving ? classes.disabledButton : classes.buttonCancel}
            >
                <Typography variant="h5">
                    <span className={classes.cancelMessage}>
                        <CancelOutlinedIcon className={classes.icon} />{" "}
                        {t("HMI.cluster.cancel_button").toUpperCase()}
                    </span>
                </Typography>
            </button>
            <button
                onClick={onConfirm}
                type="button"
                disabled={isSaving}
                className={isSaving ? classes.disabledButton : classes.buttonConfirm}
            >
                <Typography variant="h5">
                    <span className={classes.confirmMessage}>
                        <DoneOutlinedIcon className={classes.icon} />{" "}
                        {t("HMI.cluster.confirm_button").toUpperCase()}
                    </span>
                </Typography>
            </button>
        </Box>
    );
};

